/**
 * Access token cached across page reloads within the same tab session
 * (sessionStorage — cleared on tab close), so a reload doesn't force
 * re-entering credentials every time in DevModePanel. Never caches the
 * credentials themselves (password/clientSecret): only the short-lived
 * token, so once it actually expires a real re-login is still required —
 * same limitation the "paste a token" tab already has.
 */
const TOKEN_STORE_KEY = 'archer-dev-mode-token';

interface PersistedToken {
  accessToken: string;
  expiresAtMs: number;
}

export function loadCachedDevToken(): string | null {
  try {
    const raw = sessionStorage.getItem(TOKEN_STORE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedToken;
    if (!parsed.accessToken || parsed.expiresAtMs <= Date.now()) return null;
    return parsed.accessToken;
  } catch {
    return null;
  }
}

export function saveCachedDevToken(accessToken: string, expiresInSec: number | undefined): void {
  if (!expiresInSec) return;
  const data: PersistedToken = { accessToken, expiresAtMs: Date.now() + expiresInSec * 1000 };
  sessionStorage.setItem(TOKEN_STORE_KEY, JSON.stringify(data));
}

export function clearCachedDevToken(): void {
  sessionStorage.removeItem(TOKEN_STORE_KEY);
}
